import type { PaginationMetadata, PaginationQuery } from './common'

// ponytail: fixed set, not master data — validate against this on both FE
// (form Select) and BE (schema enum) instead of a manageable category table.
export const UNIT_OF_MEASUREMENT_CATEGORIES = [
  'length',
  'area',
  'volume',
  'mass',
  'time',
  'quantity',
  'other',
] as const

export type UnitOfMeasurementCategory =
  (typeof UNIT_OF_MEASUREMENT_CATEGORIES)[number]

export interface UnitOfMeasurement {
  id: string
  workspaceId: string
  name: string
  symbol: string
  category: UnitOfMeasurementCategory
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateUnitOfMeasurementReq {
  name: string
  symbol: string
  category: UnitOfMeasurementCategory
  // Only honored for actors with canSwitchWorkspace — everyone else always
  // creates in their own workspace regardless of what's sent here.
  workspaceId?: string
}

export interface UpdateUnitOfMeasurementReq {
  name?: string
  symbol?: string
  category?: UnitOfMeasurementCategory
  isActive?: boolean
}

export interface GetUnitOfMeasurementReq {
  q?: string
  category?: UnitOfMeasurementCategory
  isActive?: boolean
  pagination?: PaginationQuery
}

export interface UnitOfMeasurementList {
  items: UnitOfMeasurement[]
  pagination: PaginationMetadata
}

export interface UomUsageItem {
  name: string
  count: number
  isMovement?: boolean
}

export interface UomUsageSummary {
  inUse: boolean
  hasConversions: boolean
  conversionCount: number
  usages: UomUsageItem[]
  reason?: string
}

// Meaning: 1 fromUnitId = factor * toUnitId (e.g. from=sak, to=kg, factor=40).
export interface UnitConversion {
  id: string
  workspaceId: string
  fromUnitId: string
  toUnitId: string
  factor: number
  createdAt: string
  updatedAt: string
}

export interface CreateUnitConversionReq {
  fromUnitId: string
  toUnitId: string
  factor: number
  // Only honored for actors with canSwitchWorkspace — everyone else always
  // creates in their own workspace regardless of what's sent here.
  workspaceId?: string
}

export interface UpdateUnitConversionReq {
  fromUnitId?: string
  toUnitId?: string
  factor?: number
  confirmed?: boolean
}

export interface PreviewConversionImpactReq {
  factor: number
}

export interface ConversionAffectedProduct {
  productId: string
  productName: string
  recipeId: string
  currentCogs: number
  newCogs: number
}

export interface ConversionImpactPreview {
  conversionId: string
  newFactor: number
  affectedCount: number
  items: ConversionAffectedProduct[]
}

export interface UnitConversionList {
  items: UnitConversion[]
  pagination: PaginationMetadata
}
